import React from 'react'
import styles from './styles.module.scss'
import LoadingDots from '@/src/components/loadings/loading-dots/loading-dots'

type Theme = 'primary' | 'inverted'
export type ActionButtonSize = 'small' | 'medium' | 'large'

interface BaseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode
    className?: string
    theme?: Theme
    size: ActionButtonSize
}

interface SvgProps extends BaseProps {
    svg: React.JSX.Element
    isLoading?: never
}

interface LoadingProps extends BaseProps {
    svg?: never
    isLoading: boolean
}

type Props = SvgProps | LoadingProps | (BaseProps & { svg?: never; isLoading?: never })

/** Componente de botão que segue o layout do MenuDino. */
export default function ActionButton(props: Props) {
    const {
        children,
        className,
        svg,
        isLoading,
        theme,
        size,
        ...buttonProps
    } = props

    const getTheme = () => {
        if (theme === 'primary' || theme === undefined) return styles.primary
        return styles.inverted
    }

    const getBtnSize = () => {
        if (size === 'small')
            return `${styles.small} font-sm`
        else if (size === 'large')
            return `${styles.large} font-xmd`
        else
            return `${styles.medium} font-md`
    }

    return (
        <button
            disabled={isLoading}
            className={`${styles.container} ${getBtnSize()} ${getTheme()} ${className ?? ''}`}
            {...buttonProps}
        >
            {svg}
            {isLoading ? <LoadingDots /> : children}
        </button>
    )
}
